import { render, staticRenderFns } from "./tenant_config_views_reports.vue?vue&type=template&id=00bb4c30&"
import script from "./tenant_config_views_reports.vue?vue&type=script&lang=js&"
export * from "./tenant_config_views_reports.vue?vue&type=script&lang=js&"
import style0 from "./tenant_config_views_reports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports